import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      {[1, 2].map(item => (
        <Box key={item} className="skeleton-comment-item-container">
          <Skeleton className="skeleton-comment-item-avatar" variant="circle" />
          <Box className="skeleton-comment-item-ballon">
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="40%" />
          </Box>
        </Box>
      ))}
      <Skeleton className="skeleton-comment-input" variant="rect" />
    </Box>
  );
};

export default Loading;
